import Config from '../../../../config';
import FetchApi from '../../../../core/fetch/FetchApi';
import generateValidUrl from '../../../../core/fetch/generateValidUrl';
import { HttpMethods } from '../../../../core/fetch/HttpMethod';
import formatRequestBody from '../../../../temp/formatRequestBody';
import { IPwaInstallReportRequest, IPwaInstallReportResult } from '../types';
import { parsePwaInstallResponse } from '../utils/parsePwaInstallResponse';

export interface IReportPwaInstallDeps {
    fetchFn?: typeof FetchApi.fetch;
}

/**
 * Reports PWA install to PHP (`set_pwa_install`) and normalizes the response.
 */
export async function reportPwaInstall(
    request: IPwaInstallReportRequest,
    deps: IReportPwaInstallDeps = {}
): Promise<IPwaInstallReportResult> {
    const fetchFn = deps.fetchFn ?? FetchApi.fetch.bind(FetchApi);

    try {
        const response = await fetchFn(
            generateValidUrl(Config.BASE_URL),
            formatRequestBody(Config.SET_PWA_INSTALL_URL, request.user.Userid, {
                platform: request.platform,
            }),
            HttpMethods.POST,
            request.token,
            request.user
        );

        const payload = await response.json();
        return parsePwaInstallResponse(payload);
    } catch {
        return { status: 'error', bonusCoins: 0, note: 'NetworkError' };
    }
}
